const _convertMillimetersToMeters = millimeters => {
  return Number(Number(millimeters / 1000).toFixed(2))
}

export const getContentDescription = ({makeModel, vehicleInsights, i18n}) => {
  if (!vehicleInsights) return
  const {
    bodyType,
    countDoorsOptions,
    countVersions,
    fuelTypes,
    make,
    maxAcceleration,
    maxFuelType,
    maxHeight,
    maxHp,
    maxLength,
    maxLuggageCapacity,
    maxPrice,
    maxWidth,
    minAcceleration,
    minFuelType,
    minHeight,
    minHp,
    minLength,
    minLuggageCapacity,
    minPrice,
    minWidth
  } = vehicleInsights

  const hasMoreThanOneDoorSize = countDoorsOptions > 1

  const displaySecondParagraph = minLength && minWidth && minHeight && minLuggageCapacity

  const firstParagraph = i18n.t('MODEL_DETAIL.DYNAMIC_DESCRIPTION.FIRST_PARAGRAPH', {
    makeModel,
    bodyType,
    make,
    countVersions,
    minPrice: i18n.c(minPrice),
    maxPrice: i18n.c(maxPrice)
  })
  const secondParagraph = i18n.t(
    `MODEL_DETAIL.DYNAMIC_DESCRIPTION.SECOND_PARAGRAPH.${
      hasMoreThanOneDoorSize ? 'MORE_THAN_ONE_DOOR_TYPE' : 'ONE_DOOR_TYPE'
    }`,
    {
      length: _convertMillimetersToMeters(minLength),
      width: _convertMillimetersToMeters(minWidth),
      height: _convertMillimetersToMeters(minHeight),
      luggageCapacity: minLuggageCapacity,
      maxLength: _convertMillimetersToMeters(maxLength),
      maxWidth: _convertMillimetersToMeters(maxWidth),
      maxHeight: _convertMillimetersToMeters(maxHeight),
      maxLuggageCapacity
    }
  )

  const thirdParagraph = i18n.t(`MODEL_DETAIL.DYNAMIC_DESCRIPTION.THIRD_PARAGRAPH`, {
    makeModel,
    countFuelType: fuelTypes.length,
    listFuels: fuelTypes.join(', ')
  })

  const fourthParagraph = i18n.t(`MODEL_DETAIL.DYNAMIC_DESCRIPTION.FOURTH_PARAGRAPH`, {
    makeModel,
    maxHp,
    minHp,
    maxFuelType,
    minFuelType,
    maxAcceleration,
    minAcceleration
  })

  return `
      ${firstParagraph} 
      ${displaySecondParagraph ? secondParagraph : ''}
      ${thirdParagraph}
      ${fourthParagraph}
      `
}
